import { useState } from "react";
import { useNavigate } from "react-router-dom";

const vehicles = [
    {
        image: "/images/mercedes_sprinter_15.png",
        title: "Mercedes Benz Sprinter 15 Passenger Van",
        description: "Perfect for group transportation, events, weddings, and corporate outings. Offers comfortable seating for up to 15 passengers with generous luggage capacity.",
    },
    {
        image: "/images/merceds_sprinter_12.png",
        title: "Mercedes Benz Sprinter 12 Passenger Van",
        description: "Perfect for small group transportation, corporate travel, and airport transfers. Enjoy spacious seating, premium comfort, and a smooth ride for up to 12 passengers.",
    },
    {
        image: "/images/mercedes_ eSprinter.png",
        title: "Mercedes-Benz eSprinter Van",
        description: "Mercedes-Benz's fully electric van offering sustainable transportation without compromising comfort, technology, or performance.",
    },
    {
        image: "/images/mercedes_sprinter_high _roof.png",
        title: "Mercedes-Benz Sprinter High Roof Van",
        description: "Provides maximum interior space and standing room. Ideal for long-distance charter services requiring superior passenger comfort.",
    },
    {
        image: "/images/mercedes_sprinter_luxury_limo.png",
        title: "Mercedes-Benz Sprinter Luxury Limo Van",
        description: "A premium executive vehicle featuring luxury captain seats, ambient lighting, entertainment systems, and first-class comfort for VIP clients.",
    },
    {
        image: "/images/mercedes_v_class.png",
        title: "Mercedes-Benz V-Class Executive",
        description: "A luxury MPV combining elegance, comfort, and versatility. Perfect for executive travel, airport transfers, and small-group transportation.",
    },
];

export const Fleets = () => {
    const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = useState(0);

    const cardsPerView = window.innerWidth < 768
        ? 1
        : window.innerWidth < 1024
            ? 2
            : 3;;

    const nextSlide = () => {
        if (currentIndex < vehicles.length - cardsPerView) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };


    return (
        <section className="bg-primary py-20 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4">

                {/* Header */}
                <div className="text-center">
                    <h2 className="text-4xl md:text-5xl font-semibold text-white">
                        Vehicles for Every Journey
                    </h2>

                    <p className="text-white/90 mt-5 max-w-3xl mx-auto">
                        Whether you're traveling solo, with family, or as part
                        of a large group, we have the perfect vehicle.
                    </p>
                </div>

                {/* Arrows */}
                <div className="flex justify-end gap-3 mt-10">
                    <button
                        onClick={prevSlide}
                        disabled={currentIndex === 0}
                        className="w-10 h-10 rounded-full bg-white flex items-center justify-center disabled:opacity-40"
                    >
                        <span className="material-symbols-outlined text-primary">chevron_backward</span>
                    </button>

                    <button
                        onClick={nextSlide}
                        disabled={
                            currentIndex >= vehicles.length - cardsPerView
                        }
                        className="w-10 h-10 rounded-full bg-white flex items-center justify-center disabled:opacity-40"
                    >
                        <span className="material-symbols-outlined text-primary">chevron_forward</span>
                    </button>
                </div>

                {/* Slider */}
                <div className="overflow-hidden mt-8">
                    <div
                        className="flex gap-8 transition-transform duration-500"
                        style={{
                            transform: `translateX(-${currentIndex * (111 / cardsPerView)
                                }%)`,
                        }}
                    >
                        {vehicles.map((vehicle, index) => (
                            <div
                                key={index}
                                className="w-full xs:w-full md:w-[calc(50%-16px)] xl:w-[calc(33.333%-22px)] bg-white rounded-2xl p-6 shrink-0 flex flex-col gap-[6px] text-center"
                            >
                                <img
                                    src={vehicle.image}
                                    alt={vehicle.title}
                                    className="w-full h-64 object-contain"
                                />

                                <h3 className="text-[#00A3FF] text-2xl font-medium mt-6">
                                    {vehicle.title}
                                </h3>

                                <p className="mt-5 text-gray-500 text-[13px]">
                                    {vehicle.description}
                                </p>

                                <button className="px-8 py-3 w-max bg-[#005EA9] text-white rounded-full mx-auto mt-auto"
                                    onClick={() => navigate("/contact-us")}
                                >
                                    Reserve Now
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    )
}